import React, { PropsWithChildren } from "react";
import { Card, Box } from "@chakra-ui/react";

interface AppCardProps extends React.HTMLAttributes<HTMLDivElement> {
  header?: string | React.ReactNode;
  headerClass?: string;
  footer?: string | React.ReactNode;
  footerClass?: string;
  className?: string;
}

const AppCard: React.FC<PropsWithChildren<AppCardProps>> = ({
  header,
  headerClass,
  footer,
  footerClass,
  className,
  children,
  ...rest // Spread the remaining props
}) => {
  return (
    <Card.Root className={`border-none ${className}`} {...rest}>
      <Card.Header>
        <Box className={headerClass}>{header}</Box>
      </Card.Header>
      <Card.Body>
        <Box>{children}</Box>
      </Card.Body>
      <Card.Footer>
        <Box className={footerClass}>{footer}</Box>
      </Card.Footer>
    </Card.Root>
  );
};

export default AppCard;

// interface AppCardProps {
//   header?: string | React.ReactNode;
//   headerClass?: string;
//   footer?: string | React.ReactNode;
//   footerClass?: string;
//   className?: string;
// };

// const AppCard: React.FC<PropsWithChildren<AppCardProps>> = ({
//   header,
//   headerClass,
//   footer,
//   footerClass,
//   children,
//   className,
// }) => {
//   return (
//     <Card.Root className={className}>
//       <Card.Header>
//         <Box className={headerClass}>{header}</Box>
//       </Card.Header>
//       <Card.Body>
//         <Box>{children}</Box>
//       </Card.Body>
//       <Card.Footer>
//         <Box className={footerClass}>{footer}</Box>
//       </Card.Footer>
//     </Card.Root>
//   );
// };

// export default AppCard;
